import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./ActionButton.module.scss"

// maps a key to a style class in ActionButton.module.scss
enum StylePreset {
  primary = "actionButtonPrimary",
  secondary = "actionButtonSecondary",
  destructive = "actionButtonDestructive",
}

type StylePresetKey = keyof typeof StylePreset
export const defaultStylePreset: StylePresetKey = "primary"

type ButtonAttributes = ComponentPropsWithoutRef<"button">

export interface Props extends ButtonAttributes {
  stylePreset?: StylePresetKey;
}

// renders a rectangular <button />
export const ActionButton = forwardRef<HTMLButtonElement, Props>(
  function ActionButton(props: Props, propRef: Ref<HTMLButtonElement>) {
    const {
      children,
      stylePreset = defaultStylePreset,
      ...htmlButtonProps
    } = props

    const className = classNames(
      htmlButtonProps.className,
      styles[StylePreset[stylePreset]],
    )

    return (
      <button
        type="button"
        {...htmlButtonProps}
        ref={propRef}
        className={className}
      >
        <span className={styles.actionButtonText}>
          {children}
        </span>
      </button>
    )
  },
)
